export class RequestExperiments {
    #f: string[] = [];
    #p = 'schema_id:';

    constructor(...flags: string[]) {
        this.#f = flags;
    }

    WithFlag(flag: string, optionalCondition?: boolean): this {
        if (optionalCondition !== undefined && !optionalCondition) {
            return this;
        }

        this.#f.push(flag);
        return this;
    }

    WithSchema(id: string): this {
        const i = this.#f.findIndex((v) => v.startsWith(this.#p));
        i === -1 ? this.#f.push(this.#p + id) : (this.#f[i] = this.#p + id);
        return this;
    }

    Get(): string[] {
        return this.#f;
    }

    Has(name: string): boolean {
        return this.#f.includes(name);
    }

    Marshal(): string {
        return JSON.stringify(this.#f);
    }
}

export function getRequestExperiments(
    isWeddingBrief: boolean,
    schemaId?: string,
    referenceProjectsEnabled?: boolean
) {
    const experiments = new RequestExperiments();

    if (schemaId) {
        experiments.WithSchema(schemaId);
    }

    if (isWeddingBrief) {
        experiments.WithSchema('careDesignWeddingInvitation@Latest');
    }

    if (referenceProjectsEnabled) {
        experiments.WithFlag('reference_projects');
    }

    return experiments.Get();
}
